import { render, staticRenderFns } from "./PassengerInformationSummary.vue?vue&type=template&id=1809ca8d&scoped=true"
import script from "./PassengerInformationSummary.vue?vue&type=script&lang=js"
export * from "./PassengerInformationSummary.vue?vue&type=script&lang=js"
import style0 from "./PassengerInformationSummary.vue?vue&type=style&index=0&id=1809ca8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1809ca8d",
  null
  
)

export default component.exports